"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function checkStringEnum(obj, enumVal) {
    return Object.keys(obj).filter(function (key) { return obj[key] === enumVal; }).length === 1;
}
exports.checkStringEnum = checkStringEnum;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/common/index.js
 ** module id = 956
 ** module chunks = 0
 **/